<template>
<div id="app">
    <router-view :key="$route.fullPath" />

</div>
</template>

<script>
import gql from 'graphql-tag'
import { mapMutations, mapGetters } from 'vuex'
import mixins from '@/mixins/mixins'

export default {
    metaInfo: {
        titleTemplate: '%s - Doctor Consultas',
        title: 'Doctor Consultas',
        htmlAttrs: {
            lang: 'es',
            amp: true
        }
	},
	mixins:[mixins],
    computed: {
		...mapGetters(['isAuthenticated','loggedUser'])
    },
    beforeMount() {
        this.loadMe();
        this.searchCommingVideochat();
    },
    updated() {
        this.loadMe();
        this.searchCommingVideochat();
    },
    mounted(){
        // console.log(this.$installer)
    },
    methods:{
        ...mapMutations(['updateLoggedUserData']),
		loadMe(){
			if( this.isAuthenticated){
				this.$apollo.query({
					query: gql`query {
						me {
							id
							fullname
                            name
                            lastname
							gender
							email
                            is_completed
							picture{
								id
								filename
								urlThumb
							}
						}
					}`,
					fetchPolicy: 'no-cache',
				})
				.then((data) => {
                    if(data.data.me){
                        this.updateLoggedUserData( {loggedUser:data.data.me});
                    }else{
                        this.$router.push('/logout');
                    }
				});
			}
		},
		
		
	},
}
</script>

<style>

</style>
